import React, { useContext, useMemo } from 'react'
import { createPortal } from 'react-dom'

import Select from '@/components/shared/ui/Select'
import type { ISelectOption } from '@/components/shared/ui/Select/Select'
import HNContext from '@/context/HNContext'
import type { IOrganizationCustomization } from '@/types/organization'

const groupMechnismOptions = [
  { label: 'Group by State', value: 'state' },
  { label: 'Group by Status', value: 'status' },
  { label: 'Group by Quarter', value: 'quarterly' },
  { label: 'Group by Month', value: 'monthly' },
]

interface IPropTypes {
  groupMechnism: string
  onChange: ISelectOption['onChange']
  mountOnHeader?: boolean
}
export default function RoadmapLaneGroupSelect({
  groupMechnism,
  onChange,
  mountOnHeader,
}: IPropTypes) {
  const { isAdmin, organizationSetting, organizationCustomization } =
    useContext(HNContext)

  const { roadmap_view = [] } =
    organizationCustomization as IOrganizationCustomization

  const filteredOptions = useMemo(() => {
    if (isAdmin) return groupMechnismOptions

    return groupMechnismOptions.filter((option) => {
      if (roadmap_view?.length && !roadmap_view.includes(option.value))
        return false
      if (option.value === 'state')
        return organizationSetting?.show_custom_states
      if (option.value === 'status') return true
      return true
    })
  }, [])

  if (
    (!groupMechnismOptions.length || groupMechnismOptions.length === 1) &&
    !isAdmin
  )
    return null
  if (mountOnHeader) {
    const portalRoot = document?.getElementById('lane-selector')
    return portalRoot
      ? createPortal(
          <Select
            size='xs'
            options={filteredOptions}
            value={filteredOptions.filter(
              (option) => option.value === groupMechnism
            )}
            placeholder='Group by'
            className='!rounded-md'
            onChange={onChange}
          />,
          portalRoot
        )
      : null
  }

  if (!filteredOptions.length || filteredOptions.length === 1) return null
  return (
    <div>
      <Select
        options={filteredOptions}
        value={filteredOptions.filter(
          (option) => option.value === groupMechnism
        )}
        placeholder='Group by'
        size='xs'
        onChange={onChange}
      />
    </div>
  )
}
